const Points = ({ points }) => {
    return <span className='points'><img src="./static/myspace/coin.svg" alt="" /> {points}</span>;
};

export default Points;